import { useState, useEffect, ReactNode, ReactElement } from 'react';
import Loader from '../Loader';

type IProps = {
  children: ReactNode;
  waitBeforeShow?: number;
  showLoader?: boolean;
};

const Delayed = ({ children, waitBeforeShow = 1000, showLoader = false }: IProps): ReactElement => {
  const [isShown, setIsShown] = useState(false);
  const [isLoading, setIsLoading] = useState(showLoader);

  useEffect(() => {
    if (showLoader) {
      setIsLoading(true);
    }
    const timer = setTimeout(() => {
      setIsShown(true);
      if (showLoader) {
        setIsLoading(false);
      }
    }, waitBeforeShow);
    return () => clearTimeout(timer);
  }, [waitBeforeShow, showLoader]);

  if (showLoader) {
    return isLoading ? <Loader /> : (children as ReactElement);
  }

  return isShown ? (children as ReactElement) : null;
};

export default Delayed;
